import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, tap } from 'rxjs';
import { AppConstants } from 'src/app/app-constants';
import { IAssignmentModuleCall } from 'src/app/interfaces/iassignment-module-call';
import { IEnableCallTestingResponse } from 'src/app/interfaces/self-serve/responses/ienable-call-testing-response';
import { CallFlagService } from 'src/app/services/learner/call-flag/call-flag.service';
import { AuthorService } from 'src/app/services/self-serve/author.service';
import { SimulationGenerationPollingService } from 'src/app/services/self-serve/simulation-generation-polling.service';

@Injectable({
  providedIn: 'root',
})
export class TestSimulationLauncherService {
  constructor(
    private authorService: AuthorService,
    private callFlagService: CallFlagService,
    private pollingService: SimulationGenerationPollingService,
    private router: Router
  ) {}

  launchTestSimulation(
    callUuid: string,
    moduleUuid: string,
    currentUserUuid: string
  ): Observable<IEnableCallTestingResponse> {
    return this.authorService.enableCallTesting(callUuid, [currentUserUuid], moduleUuid).pipe(
      tap((res) => {
        const call = {
          callUuid: res.callUuid,
          callType: res.callType,
          tavusEnabled: res.tavusEnabled,
          pauseEnabled: res.pauseEnabled,
          visualAidEnabled: res.visualAidEnabled,
          callThumbnail: res.callThumbnail,
          language: res.language,
        } as IAssignmentModuleCall;

        this.callFlagService.saveCallFlags([call]);
        this.callFlagService.markTestSession({ callUuid: res.callUuid, moduleUuid, userUuid: currentUserUuid });
        this.pollingService.dismiss(callUuid);
        this.router.navigate(['/call'], {
          queryParams: {
            moduleAssignmentUuid: res.moduleAssignmentUuid,
            callUuid: res.callUuid,
            practiceType: AppConstants.TYPE_PRACTICE,
            callType: res.callType,
          },
        });
      })
    );
  }
}
